export const FETCH_METRICS = "FETCH_METRICS";
export const FETCH_METRICS_FILTERS = "FETCH_METRICS_FILTERS";
export const RESET_METRICS = "RESET_METRICS";
export const FETCH_METRICS_START = "FETCH_METRICS_START";
export const FETCH_METRICS_PROGRESS = "FETCH_METRICS_PROGRESS";
export const FETCH_METRICS_SUCCESS = "FETCH_METRICS_SUCCESS";
export const FETCH_METRICS_FAIL = "FETCH_METRICS_FAIL";

const START_METRICS_RUN_REQUEST = "START_METRICS_RUN_REQUEST";
const FETCH_METRICS_RUN_REQUEST = "FETCH_METRICS_RUN_REQUEST";

const defaultRunProgress = (runId) => ({
  runId,
  status: "pending",
  stage: "Starting",
  processedCount: 0,
  totalCount: 0,
  percentage: 0,
});

const getErrorMessage = (error) => {
  if (typeof error?.response?.data === "string" && error.response.data.trim()) {
    return error.response.data;
  }

  if (typeof error?.error?.message === "string" && error.error.message.trim()) {
    return error.error.message;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return "Unable to generate metrics.";
};

const applyRunState = (dispatch, data) => {
  if (!data) {
    return null;
  }

  if (data.status === "completed" && data.result) {
    dispatch({
      type: FETCH_METRICS_SUCCESS,
      payload: data,
    });

    return data;
  }

  const progress = {
    ...defaultRunProgress(data.runId),
    ...(data.progress || {}),
    runId: data.runId,
    status: data.status || data.progress?.status || "running",
  };

  if (progress.status === "failed") {
    dispatch({
      type: FETCH_METRICS_FAIL,
      payload: {
        runId: data.runId,
        error: progress.error || "Unable to generate metrics.",
      },
    });

    return data;
  }

  dispatch({
    type: FETCH_METRICS_PROGRESS,
    payload: progress,
  });

  return data;
};

export const fetchMetrics = (filter) => (dispatch) => {
  dispatch({
    type: FETCH_METRICS_START,
  });

  return dispatch({
    type: START_METRICS_RUN_REQUEST,
    payload: {
      request: {
        url: "metrics/start",
        method: "POST",
        data: filter || {}
      }
    }
  }).then((response) => {
    const runId = response?.payload?.data?.runId;

    dispatch({
      type: FETCH_METRICS_PROGRESS,
      payload: defaultRunProgress(runId),
    });

    return runId;
  }).catch((error) => {
    dispatch({
      type: FETCH_METRICS_FAIL,
      payload: {
        error: getErrorMessage(error),
      },
    });

    throw error;
  });
};

export const fetchMetricsRunState = (runId) => (dispatch, getState) => {
  if (!runId) {
    return Promise.resolve(null);
  }

  return dispatch({
    type: FETCH_METRICS_RUN_REQUEST,
    payload: {
      request: {
        url: `metrics/${runId}`,
        method: "GET",
      }
    }
  }).then((response) => applyRunState(dispatch, response?.payload?.data)).catch((error) => {
    const status = error?.response?.status;
    const metricsState = getState ? getState().metricsReducer : null;
    const isStaleMissingRun = status === 404 &&
      metricsState &&
      metricsState.runId !== runId;

    if (isStaleMissingRun) {
      return null;
    }

    dispatch({
      type: FETCH_METRICS_FAIL,
      payload: {
        runId,
        error: getErrorMessage(error),
      },
    });

    throw error;
  });
};

export const receiveMetricsProgress = (progress) => (dispatch, getState) => {
  if (!progress) {
    return;
  }

  const metricsState = getState ? getState().metricsReducer : null;
  if (metricsState?.runId && progress.runId && metricsState.runId !== progress.runId) {
    return;
  }

  if (progress.status === "failed") {
    dispatch({
      type: FETCH_METRICS_FAIL,
      payload: {
        runId: progress.runId,
        error: progress.error || "Unable to generate metrics.",
      },
    });

    return;
  }

  dispatch({
    type: FETCH_METRICS_PROGRESS,
    payload: progress,
  });
};

export const fetchMetricsFilters = (filterState) => ({
  type: FETCH_METRICS_FILTERS,
  payload: {
    request: {
      url: "metrics/filters",
      method: "POST",
      data: filterState || {}
    }
  }
});

export const resetMetrics = () => ({
  type: RESET_METRICS
});
